import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/raas`

    const headers = { responseType: "arraybuffer" }

    return {
        relatorioInconsistencia(queryParms) {
            return repository.get(`${baseUrl}/relatorio-inconsistencia?${urlUtil.serialize(queryParms)}`, headers)
        },
    }
}
